// @ts-nocheck
/**
 * @generated
 * @file GreenchoiceSumthing (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import BlockContainer from "./webflow_modules/Layout/components/BlockContainer";
import Heading from "./webflow_modules/Basic/components/Heading";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import RichText from "./webflow_modules/Basic/components/RichText";
import Section from "./webflow_modules/Layout/components/Section";

/**
 * Props for {@link GreenchoiceSumthing}
 */
export type GreenchoiceSumthingProps = {
  title?: React.ReactNode;
};

/**
 * GreenchoiceSumthing
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
export function GreenchoiceSumthing({
  title = "Over Natuur voor Morgen",
}: GreenchoiceSumthingProps) {
  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <Section
        className={"section-greenchoice greenchoice-green"}
        grid={{
          type: "section",
        }}
        tag={"section"}
      >
        <BlockContainer
          className={"container-greenchoice"}
          grid={{
            type: "container",
          }}
          tag={"div"}
        >
          <Block className={"div-block-294"} tag={"div"}>
            <Block className={"vertical-flex-greenchoice _40"} tag={"div"}>
              <Heading className={"h2-greenchoice white"} tag={"h2"}>
                {title}
              </Heading>
              <RichText className={"rich-text-greenchoice white"} tag={"div"}>
                <Paragraph>
                  {
                    "Natuur voor Morgen is het natuurprogramma van Greenchoice. Via het programma investeren we samen met onze klanten in natuurprojecten in Nederland en andere delen van de wereld. Wil je meer weten over waarom we dit doen, hoe we projecten kiezen en hoe je als klant bijdraagt? Lees dan verder op "
                  }
                  <Link
                    button={false}
                    options={{
                      href: "https://www.greenchoice.nl/natuur-voor-morgen/",
                    }}
                  >
                    {"Greenchoice.nl"}
                  </Link>
                  {"."}
                </Paragraph>
              </RichText>
            </Block>
            <Block className={"div-block-295"} tag={"div"}>
              <Image
                alt={""}
                className={"image-greenchoice home-header footer"}
                height={"auto"}
                loading={"lazy"}
                src={
                  "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69cb8b66f93c8a05faa6ce7f_TeamGreen.jpg"
                }
                width={"auto"}
              />
            </Block>
            <HtmlEmbed
              content={
                "<style>\n.w-richtext h1,\n.w-richtext h2,\n.w-richtext h3,\n.w-richtext h4 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n.w-richtext p {\n  margin-bottom: 10px;\n}\n.w-richtext ul,\n.w-richtext ol {\n  padding-left: 40px;\n  margin-bottom: 10px;\n}\n.w-richtext img {\n  max-width: 100%;\n}\n.w-richtext a {\n  color: inherit;\n  text-decoration: underline;\n}\n.w-richtext blockquote {\n  border-left: 3px solid currentColor;\n  padding-left: 20px;\n  margin-left: 0;\n}\n.w-richtext figure {\n  margin: 0 0 10px;\n}\n</style>"
              }
            />
          </Block>
        </BlockContainer>
      </Section>
    </div>
  );
}
